export const ROUTES = {
    home: '/',
    djContact: '/home/djContact',
    customerContact: '/home/customerContact',
    customerHome: '/customerHome',
}